export const ERoutes = {
  METER: "/meter",
  DIP: "/dip",
  PURCHASE: "/purchase",
  LUBE_SALE: "/lubeSale",
  CARDS: "/cards",
  CREDITS: "/credits",
  RECEIPT: "/receipts",
  PAYMENT: "/payment",
  JV: "/journalVoucher",
  DAILYSHEET: "/dailySheet",
  BULK_SALE: "/bulkSale",
  BULK_PURCHASE: "/bulkPurchase",
  VEHICAL: "/createVehical",
  BANK: "/bankVoucher",
  EXPENSE: "/expenseVoucher",
  PETTY_EXPENSE: "/pettyExpenseVoucher",

};
